import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { withCache } from '@ngneat/cashew';
import { environment } from '@y42/environment';
import { setGitPathHttpHeader } from '@y42/feature/git';
import { ORG_API_URL_PARAM } from '@y42/model';
import { Observable, map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ViewManagerHttpService {
  constructor(private readonly httpClient: HttpClient) {}

  private readonly url = `${environment.url.view_manager_api}/orgs/${ORG_API_URL_PARAM}/view/link`;
  private readonly cacheKeyPrefix = this.url;

  getDwhLinkForTable(tableId: string): Observable<string> {
    return this.httpClient
      .get<{ link: string }>(this.url, {
        headers: setGitPathHttpHeader(tableId),
        context: withCache({
          key: `${this.cacheKeyPrefix}|${tableId}`,
        }),
      })
      .pipe(map((response) => response.link));
  }
}
